export enum RewardsProgramType {
  Agronomy = 'agronomy',
  Energy = 'energy',
}
